import { Component } from "@angular/core";
import { EasterFlipClockComponent } from "../flip-clock/flip-clock.component";

@Component({
    selector: 'app-easter-header',
    imports: [EasterFlipClockComponent],
    template: `
     <div class="tw-bg-[url('https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/Easter+Campaign+Background.webp')] tw-bg-cover tw-bg-center lg:tw-bg-[length:100%_100%] lg:tw-bg-no-repeat
        tw-min-h-[60vh] md:tw-min-h-[70vh] tw-px-5 md:tw-px-10">
        <div class="tw-w-full tw-flex tw-justify-center tw-pt-8 md:tw-pt-14">
            <h1 class="tw-text-v4-yellow-1 tw-uppercase tw-font-black tw-text-center tw-text-2xl md:tw-text-4xl lg:tw-text-5xl" style="font-family: 'Montserrat', 'Poppins', 'Open Sans', sans-serif; -webkit-text-stroke: 1px currentColor;">
                NUSTONE'S EASTER MEGA SALE 2026
            </h1>
        </div>
        <div class="tw-w-full tw-flex tw-flex-col tw-items-center tw-text-center tw-py-4 tw-mt-4 md:tw-mt-10">
            <p class="tw-font-black tw-text-white tw-leading-tight tw-text-2xl md:tw-text-5xl lg:tw-text-7xl" style="font-family: 'Montserrat', 'Poppins', 'Open Sans', sans-serif; -webkit-text-stroke: 1px white;">
                Get <span class="tw-text-v4-yellow-1" style="-webkit-text-stroke: 1px currentColor;">FLAT 10%</span> off - Use Code <span class="tw-text-v4-yellow-1" style="-webkit-text-stroke: 1px currentColor;">EASTER10</span>
            </p>
            <!-- <p class="tw-font-black tw-text-white tw-leading-tight tw-text-2xl md:tw-text-5xl lg:tw-text-7xl" style="font-family: 'Montserrat', 'Poppins', 'Open Sans', sans-serif; -webkit-text-stroke: 1px white;">
                with code <span class="tw-text-v4-yellow-1" style="-webkit-text-stroke: 1px currentColor;">EASTER10</span>
            </p> -->
            <p class="tw-text-white tw-text-sm md:tw-text-lg lg:tw-text-xl tw-mt-2 tw-font-medium tw-tracking-widest" style="font-family: 'Montserrat', 'Poppins', 'Open Sans', sans-serif; -webkit-text-stroke: 0.5px white;">
                No complications. Just instant savings.
            </p>
        </div>
        <div class="tw-w-full tw-flex tw-flex-col lg:tw-flex-row tw-gap-6 lg:tw-gap-20 tw-items-center tw-pb-10 tw-mt-8 lg:tw-mt-20 tw-justify-center">
            <div class="tw-hidden lg:tw-flex lg:tw-basis-3/12 tw-justify-end">
                <img class="tw-w-2/4" src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/Ends_Icon (1).png" />
            </div>
            <div class="tw-w-full lg:tw-basis-4/12 tw-flex tw-flex-col tw-gap-3 tw-items-center">
                <h2 class="tw-uppercase tw-text-white tw-text-center tw-w-full tw-text-xl md:tw-text-3xl lg:tw-text-4xl" style="font-weight: bolder; font-family: 'Montserrat', 'Poppins', 'Open Sans', sans-serif; -webkit-text-stroke: 1px white;">BIG SAVINGS AWAIT YOU!</h2>
                <div class="tw-w-full">
                    <app-easter-flip-clock [targetDate]="'2026-04-19T00:00:00'" displayStyle="flip"></app-easter-flip-clock>
                </div>
            </div>
            <div class="tw-hidden lg:tw-flex lg:tw-basis-3/12 tw-justify-start">
                <img class="tw-w-2/4" src="https://nustone-bucket.s3.eu-west-2.amazonaws.com/assets/while+stock+last.webp" />
            </div>
        </div>
     </div>
     <div class="tw-bg-v4-yellow-1 tw-w-full tw-h-4"></div>
  `
})
export class EasterHeaderComponent { }
